import { reducerWithInitialState } from 'typescript-fsa-reducers'
import cleanDeep from 'clean-deep'
import produce from 'immer'

import { AsyncModel } from '~shared/models/AsyncModel'

import {
  NewUserFormAvailableSteps,
  resetForm,
  setCurrentStep,
  submitForm,
  updateFormStepValues,
  updateFormStepValuesAndSubmit,
  UpdateFormStepValuesProps,
  updateFormValues,
} from './actions'
import { NewUserForm } from '~api/models'

export interface NewUserFormWizardState {
  readonly submitData: AsyncModel<undefined>
  data: Partial<NewUserForm>
  currentStep: NewUserFormAvailableSteps
}

const INITIAL_STATE: NewUserFormWizardState = {
  data: {}, // has to be initialized for Object.assign to work properly
  submitData: {},
  currentStep: 'step1',
}

export const NewUserFormWizardReducer = reducerWithInitialState(INITIAL_STATE)
  /**
   * update form values
   */
  .case(updateFormValues, (state, payload) => {
    return produce(state, (draft: NewUserFormWizardState) => {
      draft.data = payload
    })
  })

  /**
   * update form step values
   */
  .case(updateFormStepValuesAndSubmit, HandleUpdateFormStepValues)
  .case(updateFormStepValues, HandleUpdateFormStepValues)

  /**
   * set current step
   */
  .case(setCurrentStep, (state, payload) => {
    return produce(state, (draft: NewUserFormWizardState) => {
      draft.currentStep = payload
    })
  })

  /**
   * submit form
   */
  .case(submitForm.started, (state) => {
    return produce(state, (draft: NewUserFormWizardState) => {
      draft.submitData.error = undefined
      draft.submitData.inProgress = true
    })
  })
  .case(submitForm.done, (state) => {
    return produce(state, (draft: NewUserFormWizardState) => {
      draft.submitData.inProgress = false
    })
  })
  .case(submitForm.failed, (state, payload) => {
    return produce(state, (draft: NewUserFormWizardState) => {
      draft.submitData.inProgress = false
      draft.submitData.error = payload.error
    })
  })

  /**
   * reset form
   */
  .case(resetForm, () => {
    return INITIAL_STATE
  })

function HandleUpdateFormStepValues(state: NewUserFormWizardState, payload: UpdateFormStepValuesProps) {
  return produce(state, (draft: NewUserFormWizardState) => {
    const cleanedStepValues = cleanDeep(payload.values) || {}
    Object.assign(draft.data, { [payload.step]: cleanedStepValues })
  })
}
